
import { Record } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { int32_type, bool_type, lambda_type, unit_type, record_type, option_type, class_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { day, month, year } from "../../fable_modules/fable-library-js.5.3.0/Date.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { createElement } from "react";
import { DayPicker } from "react-day-picker";

/**
 * Controlled range selection passed to / received from DayPicker.
 * Mirrors the JS `DateRange` shape: `{ from, to }` where either may be missing.
 */
export class RangeSelection extends Record {
    constructor(From, To) {
        super();
        this.From = From;
        this.To = To;
    }
}

export function RangeSelection_$reflection() {
    return record_type("Shared.DayPicker.RangeSelection", [], RangeSelection, () => [["From", option_type(class_type("System.DateTime"))], ["To", option_type(class_type("System.DateTime"))]]);
}

/**
 * Props passed to the underlying React component. Keep this minimal —
 * add only what DateRangeCalendar needs.
 */
export class Props extends Record {
    constructor(Selected, OnSelect, Disabled, StartMonth, EndMonth, NumberOfMonths) {
        super();
        this.Selected = Selected;
        this.OnSelect = OnSelect;
        this.Disabled = Disabled;
        this.StartMonth = StartMonth;
        this.EndMonth = EndMonth;
        this.NumberOfMonths = (NumberOfMonths | 0);
    }
}

export function Props_$reflection() {
    return record_type("Shared.DayPicker.Props", [], Props, () => [["Selected", RangeSelection_$reflection()], ["OnSelect", lambda_type(RangeSelection_$reflection(), lambda_type(option_type(class_type("System.DateTime")), unit_type))], ["Disabled", lambda_type(class_type("System.DateTime"), bool_type)], ["StartMonth", class_type("System.DateTime")], ["EndMonth", class_type("System.DateTime")], ["NumberOfMonths", int32_type]]);
}

/**
 * Construct a JS Date at local midnight for the given calendar date.
 * DayPicker renders cells based on the JS Date's local day. Plain `box date`
 * on a Kind=Unspecified DateTime (e.g. from UtcDateTime.Date) serializes as
 * UTC midnight, which shifts the highlight one day earlier in negative-offset
 * timezones. Using explicit year/month/day avoids the UTC→local day shift.
 */
export function toLocalCalendarDate(date) {
    return new Date(year(date), (month(date) - 1), day(date));
}

function toJsDateOrUndefined(d) {
    if (d == null) {
        return defaultOf();
    }
    else {
        return toLocalCalendarDate(d);
    }
}

function isMissing(v) {
    return v == null;
}

export function render(props) {
    return createElement(DayPicker, {
        mode: "range",
        selected: {
            from: toJsDateOrUndefined(props.Selected.From),
            to: toJsDateOrUndefined(props.Selected.To),
        },
        onSelect: function(sel, td) { return ((sel, triggerDate) => {
            const triggerOpt = isMissing(triggerDate) ? undefined : triggerDate;
            if (isMissing(sel)) {
                props.OnSelect(new RangeSelection(undefined, undefined), triggerOpt);
            }
            else {
                const fromVal = sel.from;
                const toVal = sel.to;
                props.OnSelect(new RangeSelection(isMissing(fromVal) ? undefined : fromVal, isMissing(toVal) ? undefined : toVal), triggerOpt);
            }
        })(sel)(td); },
        disabled: props.Disabled,
        startMonth: toLocalCalendarDate(props.StartMonth),
        endMonth: toLocalCalendarDate(props.EndMonth),
        numberOfMonths: props.NumberOfMonths,
    });
}

//# sourceMappingURL=DayPicker.js.map
